import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';
import { addQueryParameters } from 'utils/url';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/questions`,
  CREATE: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/questions`,
  SHOW: `${apiUrlConfig.apiEndPoint()}/questions/:id`,
  UPDATE: `${apiUrlConfig.apiEndPoint()}/questions/:id`,
  DELETE: `${apiUrlConfig.apiEndPoint()}/questions/:id`,
  SUGGESTION: `${apiUrlConfig.apiEndPoint()}/questions/suggestion`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class CustomSurveyQuestionApi {
  /**
   * add new question
   */
  static addNew(
    question,
    answers_attributes,
    ownerId,
    survey_template_question_id,
    input_type_id,
  ) {
    const CREATE_URL = insertIdToUrl(URLS.CREATE, ownerId);
    const data = {
      question: {
        question,
        answers_attributes,
        survey_template_question_id,
        input_type_id,
      },
    };

    return AuthenticatedRequestService.post(CREATE_URL, data);
  }

  /**
   * gets all questions for custom survey
   */
  static getAll(customSurveyId) {
    const INDEX_URL = insertIdToUrl(URLS.INDEX, customSurveyId);

    return AuthenticatedRequestService.get(INDEX_URL);
  }

  /**
   * get question details
   */
  static getDetails(questionId) {
    const SHOW_URL = insertIdToUrl(URLS.SHOW, questionId);

    return AuthenticatedRequestService.get(SHOW_URL);
  }

  /**
   * updates question
   */
  static update(questionId, question, answers_attributes, answer_order) {
    const UPDATE_URL = insertIdToUrl(URLS.UPDATE, questionId);

    const data = {
      question: {
        question,
        answers_attributes,
        answer_order,
      },
    };

    return AuthenticatedRequestService.patch(UPDATE_URL, data);
  }

  /**
   * Fetches suggested questions
   * @param {object} query (contains question query string and business id)
   */
  static getSuggestions(query) {
    return AuthenticatedRequestService.get(
      addQueryParameters(URLS.SUGGESTION, query)
    );
  }

  /**
   * deletes question
   */
  static delete(questionId) {
    const DELETE_URL = insertIdToUrl(URLS.UPDATE, questionId);
    const data = {
      question: {
        is_deleted: true,
      },
    };

    return AuthenticatedRequestService.patch(DELETE_URL, data);
  }
}

export default CustomSurveyQuestionApi;



// WEBPACK FOOTER //
// ./src/apis/questions/CustomSurveyQuestion.js